import React, { createContext, useState, useEffect, useContext } from 'react';
import { useContent } from './ContentContext';
import { getTemplate } from '../config/templates';
import { applyTemplate } from '../utils/templateEngine';

const TemplateContext = createContext();

export const TemplateProvider = ({ children }) => {
  const { content } = useContent();
  const [currentTemplate, setCurrentTemplate] = useState(null);

  useEffect(() => {
    const templateId = content?.selectedTemplate || 'timeless';
    const template = getTemplate(templateId);
    setCurrentTemplate(template);
    applyTemplate(template);
  }, [content?.selectedTemplate]);

  return (
    <TemplateContext.Provider value={{ currentTemplate, setCurrentTemplate }}>
      {children}
    </TemplateContext.Provider>
  );
};

export const useTemplate = () => {
  const context = useContext(TemplateContext);
  if (!context) {
    throw new Error('useTemplate must be used within a TemplateProvider');
  }
  return context;
};
